module.exports = __webpack_public_path__ + "img/气体管路1.de8d37b9.jpg";